import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HeroPhoto from "../assets/image/Sulla_Bread_Home_Page.jpg";
import "./Hero.css";
import PrimaryButton from "./PrimaryButton";

const Hero: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <section
      className="hero-section"
      data-language={i18n.language}
      lang={i18n.language === "he" ? "he" : "ru"}
    >
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="hero-title-line">{t("heroTitleLine1")}</span>
          <span className="hero-title-line">{t("heroTitleLine2")}</span>
          <span className="hero-title-line">{t("heroTitleLine3")}</span>
        </h1>
        <p className="hero-description">{t("heroDescription")}</p>

        <PrimaryButton
          onClick={() => navigate("/workshops")}
          className={i18n.language === "ru" ? "russian-button" : ""}
        >
          {t("joinWorkshops")}
        </PrimaryButton>
      </div>
      <img
        src={HeroPhoto}
        alt={t("heroImageAlt") || "תמונת כותרת - לחם ביתי איכותי מסדנאות אפייה"}
        className="hero-image"
      />
    </section>
  );
};

export default Hero;
